<template>
	<div class="head">
		<img :src="iconUrl" alt="" style="width: 20px; height: 20px" /><span class="title">{{ title }}</span>
	</div>
</template>

<script>
export default {
	props: {
		//   图标url
		iconUrl: {
			type: String,
			default: () => "@/assets/images/account/ifentify_valid_icon.png",
		},
		// 标题
		title: { type: String, default: () => "" },
	},
};
</script>

<style scoped lang="less">
.head {
	display: flex;
	align-items: center;
	.title {
		font-weight: 500;
		color: #040849;
		font-size: 16px;
		margin-left: 10px;
	}
}
</style>
